"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var core_2 = require("@21st-night/core");
var cards_web_1 = require("@21st-night/cards-web");
var editor_web_1 = require("@21st-night/editor-web");
var ActionButtons_1 = __importDefault(require("../../ActionButtons"));
var ClozeDeletionPlugin = cards_web_1.createClozeDeletionPlugin();
exports.useStyles = styles_1.makeStyles(function () { return ({
    rightColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    categories: {
        paddingTop: 36,
        flex: 1,
    },
}); });
var CardQuestionForm = function (_a) {
    var actionButtons = _a.actionButtons, errors = _a.errors, onChange = _a.onChange, value = _a.value, categorySelect = _a.categorySelect, subcategorySelect = _a.subcategorySelect, noteSelect = _a.noteSelect, other = __rest(_a, ["actionButtons", "errors", "onChange", "value", "categorySelect", "subcategorySelect", "noteSelect"]);
    var classes = exports.useStyles();
    var _b = core_2.useFirebase(), db = _b.db, storage = _b.storage, functions = _b.functions;
    return (react_1.default.createElement("div", __assign({ "data-testid": "question-editor" }, other),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 6 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 8 },
                errors.question && react_1.default.createElement(core_1.FormHelperText, { error: true }, errors.question),
                react_1.default.createElement(editor_web_1.Editor, __assign({}, { db: db, storage: storage, functions: functions }, { imageUrl: process.env.REACT_APP_IMGIX_URL, placeholder: "Write your question here...", value: value, onChange: onChange, plugins: [ClozeDeletionPlugin] }),
                    react_1.default.createElement(editor_web_1.EditorToolbar, null),
                    react_1.default.createElement(editor_web_1.EditorHoveringToolbar, null,
                        react_1.default.createElement(cards_web_1.EditorClozeDeletionButton, null)))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 4, className: classes.rightColumn },
                react_1.default.createElement("div", { className: classes.categories },
                    react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Category"),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { marginBottom: 32 } }, categorySelect),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Subcategories"),
                        subcategorySelect),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, noteSelect)),
                react_1.default.createElement(ActionButtons_1.default, { spaced: true, align: "end" }, actionButtons)))));
};
exports.default = CardQuestionForm;
//# sourceMappingURL=CardQuestionForm.js.map